import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { TranslocoService } from '@ngneat/transloco';

import { PrimeNGConfig } from 'primeng/api';

import { LoggerService, UpdateService } from '@core/services';

import { fromAuth } from '@auth/state';

@Component({
  selector: 'z-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<void>();

  constructor(
    private primengConfig: PrimeNGConfig,
    private translocoService: TranslocoService,
    private store: Store,
    private updateService: UpdateService,
    private loggerService: LoggerService
  ) {
    this.updateService.init();

    this.store
      .select(fromAuth.selectLanguage)
      .pipe(takeUntil(this.destroy$))
      .subscribe((language: string) => {
        this.translocoService.setActiveLang(language);
      });

    this.translocoService
      .selectTranslation()
      .pipe(takeUntil(this.destroy$))
      .subscribe((translations) => {
        const primeNgTranslations: Record<string, any> = {};

        for (const [key, translation] of Object.entries(translations)) {
          if (key.includes('primeng.')) {
            primeNgTranslations[key.replace(/primeng\./gi, '')] = translation;
          }
        }

        this.primengConfig.setTranslation(primeNgTranslations);
      });
  }

  ngOnInit() {
    this.loggerService.init();
    this.primengConfig.ripple = true;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
